import AdoptablesEmptyState from './AdoptablesEmptyState';
import AdoptablesEmptyStateContainer from './AdoptablesEmptyState.container';

export default AdoptablesEmptyStateContainer(AdoptablesEmptyState);
